import { AGE_GATE_PRIVACY_URL, AGE_GATE_TERMS_URL } from './age-gate';

type AgeGateModalProps = {
  onConfirm: () => void;
  onLeave: () => void;
};

export const AgeGateModal = ({ onConfirm, onLeave }: AgeGateModalProps) => (
  <div className="fixed inset-0 z-[60] flex items-center justify-center bg-black/80 px-4">
    <div className="w-full max-w-2xl rounded-2xl border-4 border-[#fdc500] bg-[#5c0099] p-5 shadow-2xl sm:p-7">
      <p className="text-sm font-bold uppercase tracking-wide text-[#fdc500]">Adult Content Warning / Age Confirmation</p>
      <h2 className="mt-2 text-2xl font-extrabold text-white">⚠️ Mature Content Notice</h2>
      <p className="mt-3 text-sm font-semibold leading-relaxed text-white/90">
        This website contains mature themes and user-generated content that may include references to sexual topics,
        violence, or other material intended for adults.
      </p>
      <p className="mt-4 text-sm font-semibold text-white">By entering this site, you confirm that:</p>
      <ul className="mt-2 list-disc space-y-2 pl-6 text-sm font-semibold text-white/90">
        <li>You are at least 18 years old (or the age of majority in your jurisdiction).</li>
        <li>You understand that this website contains adult-oriented content and discussions.</li>
        <li>You agree to view this content at your own discretion.</li>
        <li>You will not upload or share illegal, abusive, or non-consensual content.</li>
      </ul>
      <p className="mt-4 text-sm font-semibold text-white">
        If you are under 18 years old, please leave this site immediately.
      </p>
      <div className="mt-5 flex flex-col gap-2 sm:flex-row">
        <button
          type="button"
          onClick={onConfirm}
          className="rounded-lg bg-[#fdc500] px-4 py-2 text-sm font-semibold text-white btn-3d-gold"
        >
          I am 18 or older - Enter
        </button>
        <button
          type="button"
          onClick={onLeave}
          className="rounded-lg bg-[#510087] px-4 py-2 text-sm font-semibold text-white btn-3d-purple"
        >
          I am under 18 - Leave
        </button>
      </div>
      <p className="mt-4 text-xs text-white/75">
        By entering, you agree to our{' '}
        <a
          href={AGE_GATE_TERMS_URL}
          target="_blank"
          rel="noreferrer"
          className="font-semibold text-[#fdc500] underline underline-offset-2"
        >
          Terms of Service
        </a>{' '}
        and{' '}
        <a
          href={AGE_GATE_PRIVACY_URL}
          target="_blank"
          rel="noreferrer"
          className="font-semibold text-[#fdc500] underline underline-offset-2"
        >
          Privacy Policy
        </a>
        .
      </p>
    </div>
  </div>
);
